import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  authData: null,
  loggedIn: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.authData = action.payload
      state.loggedIn = true
    },
  },
})

export const { setAuthData } = authSlice.actions
export default authSlice.reducer
